<template>
	<div class="w-68 mr-auto py60">
		<form ref="form" :action="action" :method="method" @submit.prevent="validateForm">
			<div class="field is-horizontal">
				<div class="field-label is-normal">
					<label class="label" for="name">{{t('name')}}</label>
				</div>
				<div class="field-body">
					<div class="field">
						<p class="control w-80 mr-auto" v-if="edit">
							<input name="name" class="input line-input is-primary has-text-centered" v-model="form.name" v-validate="{ required: true , min:6 ,max:255, alpha_spaces:true }" :class="{'is-danger': errors.has('name') }" type="text" placeholder="">
							<span v-show="errors.has('name')" class="help is-danger has-text-centered">{{ errors.first('name') }}</span>
						</p>
						<p class="control w-80 mr-auto has-text-primary has-text-weight-bold" v-else>
							{{userObject.name}}
						</p>
					</div>
				</div>
			</div>
			<div class="field is-horizontal">
				<div class="field-label is-normal">
					<label class="label" for="phone">{{t('phone')}}</label>
				</div>
				<div class="field-body">
					<div class="field">
						<div class="control w-80 mr-auto" v-if="edit">
							<input id="phone" name="phone" class="input line-input is-primary has-text-centered" v-model="form.phone" v-validate="{ required: true ,min:9}" :class="{'is-danger': errors.has('phone') }" type="text" placeholder="" @blur="checkUniq($event,'phone')">
							<span v-show="errors.has('phone')" class="help is-danger has-text-centered">{{ errors.first('phone') }}</span>

							<span ref="phone" class="help is-danger hidden"></span>
						</div>
						<div class="control w-80 mr-auto has-text-primary has-text-weight-bold" v-else>
							{{userObject.phone}}
						</div>
					</div>
				</div>
			</div>
			<div class="field is-horizontal">
				<div class="field-label is-normal">
					<label class="label" for="email">{{t('email')}}</label>
				</div>
				<div class="field-body">
					<div class="field">
						<div class="control w-80 mr-auto" v-if="edit">
							<input id="email" name="email" class="input line-input is-primary has-text-centered" v-model="form.email" v-validate="{ required: true , email:true }" :class="{'is-danger': errors.has('email') }" type="text" placeholder="" @blur="checkUniq($event,'email')">
							<span v-show="errors.has('email')" class="help is-danger has-text-centered">{{ errors.first('email') }}</span>

							<span ref="email" class="help is-danger hidden"></span>
						</div>
						<div class="control w-80 mr-auto has-text-primary has-text-weight-bold" v-else>
							{{userObject.email}}
						</div>
					</div>
				</div>
			</div>
			<div class="field is-horizontal">
				<div class="field-label is-normal">
					<label class="label" for="city">{{t('city_id')}}</label>
				</div>
				<div class="field-body">
					<div class="field">
						<div class="control w-80 mr-auto" v-if="edit">
							<div class="select text-align-select line-input is-primary is-size-6 is-fullwidth mb15">
								<select id="city" name="city_id" v-model="form.city_id" v-validate="{ required: true }" :class="{'is-danger': errors.has('city_id') }" @change="getAreas">
									<option disabled selected :value="null">{{t('choose_city')}}</option>
									<option v-for="city in cities" :value="city.id">{{city.name}}</option>
								</select>
								<span v-show="errors.has('city_id')" class="help is-danger has-text-centered">{{ errors.first('city_id') }}</span>
							</div>
						</div>
						<div class="control w-80 mr-auto has-text-primary has-text-weight-bold" v-else>
							{{userObject.city}}
						</div>
					</div>
				</div>
			</div>
			<div class="field is-horizontal">
				<div class="field-label is-normal">
					<label class="label" for="state">{{t('area_id')}}</label>
				</div>
				<div class="field-body">
					<div class="field">
						<div class="control w-80 mr-auto" v-if="edit">
							<div class="select text-align-select line-input is-primary is-size-6 is-fullwidth mb15">
								<select id="state" name="area_id" v-model="form.area_id" v-validate="{ required: true }" :class="{'is-danger': errors.has('area_id') }" >
									<option disabled selected :value="null">{{t('choose_state')}}</option>
									<option v-if="areas" v-for="area in areas" :value="area.id">{{area.name}}</option>
								</select>
								<span v-show="errors.has('area_id')" class="help is-danger has-text-centered">{{ errors.first('area_id') }}</span>
							</div>
						</div>
						<div class="control w-80 mr-auto has-text-primary has-text-weight-bold" v-else>
							{{userObject.state}}
						</div>
					</div>
				</div>
			</div>
			<div class="field is-horizontal">
				<div class="field-label is-normal">
					<label class="label" for="full_address">{{t('address')}}</label>
				</div>
				<div class="field-body">
					<div class="field">
						<div class="control w-80 mr-auto" v-if="edit">
							<textarea rows="4" id="full_address" name="full_address" class="input line-input is-primary has-text-centered" v-model="form.full_address" v-validate="{ required: true}" :class="{'is-danger': errors.has('full_address') }" type="text" placeholder="">
                            </textarea>
							<span v-show="errors.has('full_address')" class="help is-danger has-text-centered">{{ errors.first('full_address') }}</span>
						</div>
						<div class="control w-80 mr-auto has-text-primary has-text-weight-bold" v-else>
							{{userObject.full_address}}
						</div>
					</div>
				</div>
			</div>
			<div class="field is-horizontal" v-if="!edit">
				<div class="field-label is-normal">
					<label class="label" for="name">{{t('password')}}</label>
				</div>
				<div class="field-body">
					<div class="field" v-if="!edit">
						<div class="control w-80 mr-auto has-text-primary has-text-weight-bold">
							********
						</div>
					</div>
				</div>
			</div>
			<div class="field is-horizontal" v-if="edit">
				<div class="field-label is-normal">
					<label class="label" for="name">{{t('oldPassword')}}</label>
				</div>
				<div class="field-body">
					<div class="field">
						<p class="control w-80 mr-auto">
							<input name="oldPassword" class="input line-input is-primary has-text-centered" v-model="form.password" v-validate="passwordRequired" :class="{'is-danger': errors.has('oldPassword') }" type="password" @blur="checkPassword($event,checkPass,'oldPassword')">
							<span v-show="errors.has('oldPassword')" class="help is-danger has-text-centered">{{ errors.first('oldPassword') }}</span>
                            <span ref="oldPassword" class="help is-danger hidden"></span>
						</p>
					</div>
				</div>
			</div>
			<div class="field is-horizontal" v-if="edit">
				<div class="field-label is-normal">
					<label class="label" for="name">{{t('new_password')}}</label>
				</div>
				<div class="field-body">
					<div class="field">
						<div class="control w-80 mr-auto">
							<input name="new_password" class="input line-input is-primary has-text-centered" v-model="form.new_password" v-validate="newPassRequired" ref="new_password" :class="{'is-danger': errors.has('new_password') }" type="password">
							<span v-show="errors.has('new_password')" class="help is-danger has-text-centered">{{ errors.first('new_password') }}</span>

						</div>
					</div>
				</div>
			</div>
			<div class="field is-horizontal" v-if="edit">
				<div class="field-label is-normal">
					<label class="label" for="name">{{t('new_password_confirmation')}}</label>
				</div>
				<div class="field-body">
					<div class="field">
						<div class="control w-80 mr-auto">
							<input name="new_password_confirmation" class="input line-input is-primary has-text-centered" v-model="form.new_password_confirmation" v-validate="newPassConfRequired" :class="{'is-danger': errors.has('new_password_confirmation') }" type="password">
							<span v-show="errors.has('new_password_confirmation')" class="help is-danger has-text-centered">{{ errors.first('new_password_confirmation') }}</span>
						</div>
					</div>
				</div>
			</div>

			<div class="has-text-centered">
				<a rel="noreferrer" class="button hvr-shutter-out-vertical is-rounded pl30 pr30 pt25 pb25" :class="[edit == true ? 'is-gery hvr-warning' : 'btn-warning hvr-primary']" @click="editFun()">
					{{edit == false ? t('edit'): t('cancel')}}
				</a>
				<button type="submit" class="button is-primary hvr-shutter-out-vertical hvr-primary is-rounded pl30 pr30 mr30" v-if="edit">{{t('save')}}</button>
			</div>
		</form>
	</div>
</template>

<script>
	import axios from 'axios';
	import arabic from 'vee-validate/dist/locale/ar';
	import { Validator , mapFields} from 'vee-validate';
	import trans from "../translation/user.json";
	export default {
		name: "UserProfile",
		props: {
			sitelocale:{
				type: String,
				required: true
			},
			method: {
				type: String,
				required: true
			},
			action: {
				type: String,
				required: true
			},
			userObject:{
				type: Object,
				required: true
			},
			cities:{
				type: Array,
				required: true
			},
			checkUniqueUrl:{
				type:String,
				required:true
			},
            checkPass: {
                type: String,
                required: true
            }
		},
		locales: trans,
		data: () => ({
			submitting: false,
			success: false,
			form:{
				name: '',
				phone:'',
				email:'',
				city_id:null,
				area_id:null,
				full_address:'',
				password:'',
				new_password:'',
				new_password_confirmation:'',
			},
			areas:null,
			passwordFieldType: 'password',
			edit:false,
			requiredPass:false,
		}),
		mounted() {
			this.$translate.setLang(this.sitelocale);
		},
		created() {
			this.$validator.localize('ar', {
				messages: arabic.messages,
				attributes: trans.ar,
			});
			this.$validator.localize('en', {
				attributes: trans.en,
			});
			Validator.localize(this.sitelocale);
		},
		methods: {
			editFun(){
				this.edit = !this.edit;
				if(this.edit == true){
					this.form.name= this.userObject.name;
					this.form.phone= this.userObject.phone;
					this.form.email=this.userObject.email;
					this.form.full_address = this.userObject.full_address;
					this.form.city_id = this.userObject.city_id;
					this.form.area_id = this.userObject.area_id;
					this.form.password = '';
					this.submitting=true;
					this.getAreas();
				}
			},
			getAreas(){
				this.cities.map(city => {
					if (city.id == this.form.city_id) {
						this.areas = city.areas;
					}
				});
			},
			validateForm(){
				this.$validator.validateAll().then((result) => {
					if (result) {
						this.isDisabled=true;
						const action = this.action;
						axios.post(action, this.form)
						.then(response => {
							this.showAlert('success' , ''  , response.data.data , '');
							console.log(response.data);
							setTimeout(()=>{
							    window.location.reload();
								//window.location.href = `/${this.sitelocale}/`;
							}, 2000);

						})
						.catch(error => {
							this.showAlert('error',
								`${this.$translate.text('error_in_data')}`,
								'text',
								`<ul class="AlertList">`+Object.values(error.response.data.errors).map(error => `<li class="mb5 is-size-6">${error['message']}</li>`).join(' ')+`</ul>`
								);
							this.isDisabled=false;
							console.clear();
						})
						.then(()=>{
							setTimeout(()=>{
							}, 3500);
						});
					}
				});
			},
			checkUniq(data,fieldName){
				data =  data.target.value;
				let message = this.$refs[fieldName];
				if(!this.errors.has(fieldName)){
					axios.post(this.checkUniqueUrl, {'key' : fieldName, 'value' : data })
							.then(response => {
								this.submitting = true;
								this.$refs[fieldName].classList.add('hidden');
								message.innerHTML = "";
							})
							.catch(error => {
								this.submitting = false;
								message.innerHTML = error.response.data.message;
								message.classList.remove('hidden');
							});
				}
			},
            checkPassword(data,route,fieldName){
                data =  data.target.value;
                if(data != '') {
                    let message = this.$refs[fieldName];
                    if(!this.errors.has(fieldName)){
                        axios.post(route, {'password' : data })
                            .then( response => {
                                this.submitting = true;
                                this.$refs[fieldName].classList.add('hidden');
                                message.innerHTML = "";
                            })
                            .catch(error => {
                                console.log(error);
                                this.submitting = false;
                                message.innerHTML = error.response.data.data;
                                message.classList.remove('hidden');
                            });
                    }
                }

            },
			showAlert(type , title , text , html){
				this.$swal({
					type: type,
					title: title,
					text: text,
					html: html,
					showConfirmButton: false,
					timer:2000,
					customClass: type == 'success' ? 'swal2-is-success' : 'swal2-is-danger',
					backdrop: `
					rgba(36, 140, 204, 0.5)
					`
				});
			}
		},
        computed: {
            passwordRequired(){
                return this.form.password.length > 0 ? 'min:6|max:255' : '';
            },
            newPassRequired() {
                return this.form.password.length > 0 ? 'required|min:6|max:255' : '';
            },
            newPassConfRequired() {
                return this.form.new_password.length > 0 ? 'required|min:6|max:255|confirmed:new_password' : '';
            }
        }
	};
</script>
<style type="text/css">
.hidden{
	display: none;
}
</style>
